import axios from "axios";
import { WEB_API } from "../env";
axios.defaults.baseURL = WEB_API;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.href = "/";
    }
    throw error;
  }
);

String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};

const originalFetch = window.fetch;
window.fetch = function (...args) {
  if (args[0] && args[0].includes("sentry.io")) {
    return Promise.resolve(new Response(null, { status: 204 }));
  }
  return originalFetch.apply(this, args);
};